import script from "./CasinoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasinoPage.vue?vue&type=script&setup=true&lang=ts"

import "./CasinoPage.vue?vue&type=style&index=0&id=382bdcce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382bdcce"]])

export default __exports__